<script>
    import {fly} from "svelte/transition"
    import {getGPTransFunc} from "./gp-translations.js";
    import {onMount} from "svelte";
    import {mode, selectedItemSet} from "./gp";
    let trans = getGPTransFunc("gp-hsvadjust");

    let visible = false;
    export let name = "";
    export let adjHue = 0;
    export let adjSaturation = 0;
    export let adjValue = 0;
    let resolve;
    let updateFunction;
    $: {if (updateFunction) updateFunction(adjHue, adjSaturation, adjValue)}

    onMount(() => {
        mode.subscribe(() => {if (visible) close()});
        selectedItemSet.subscribe(() => {if (visible) close()});
    })

    export function getHSV (initialHSV, updateFunc) {
        visible = true;
        updateFunction = updateFunc;
        adjHue = initialHSV.h;
        adjSaturation = initialHSV.s;
        adjValue = initialHSV.v;

        return new Promise((resolve1) => {
            resolve = resolve1;
        })
    }

    export function resetAdjustment () {
        adjHue = 0;
        adjSaturation = 0;
        adjValue = 0;
    }

    export function close() {
        visible = false;
        if (resolve) resolve({
            h: adjHue,
            s: adjSaturation,
            v: adjValue
        })
    }

</script>


{#if visible}
    <div id="hsvAdjust" class:offsetted={$selectedItemSet.length} transition:fly="{{ x: 200 }}">
        <div class="itemName">{name}</div>
        <div class="hsvAdjustInputs">
            <div><div class="lb">{trans("Hue")}:        </div><input class="" type="range" min="0" max="359" step="1" bind:value={adjHue}> </div>
            <div><div class="lb">{trans("Saturation")}: </div><input class="" type="range" min="-3" max="3" step="0.2" bind:value={adjSaturation}></div>
            <div><div class="lb">{trans("Value")}:      </div><input class="" type="range" min="-2" max="2" step="0.1" bind:value={adjValue}></div>
            <div class="hsvAdjustClear"><a on:click={resetAdjustment}>{trans("Reset to default")}</a></div>
        </div>

        <a on:click={close} href="#" class="btn hsvAdjustCloseLink" role="button"><i class="fa fa-times fa-sg"></i></a>
    </div>
{/if}